export const AUTHOR_PROFILE = {
  name: "Arsyadi Indra",
  role: "Software Engineer | AI Automation Enthusiast",
  quote:
    "I write code that works on my machine. If it doesn't work on yours, we'll just have to trade machines.",
  description:
    "Passionate about building intuitive web applications using modern tech stacks like Vue, Go, FastAPI, React, Astro, Next.js, Convex, PostgreSQL, and MongoDB. Creator of KRSan.",
  socials: {
    github: "https://github.com/indraprhmbd", // Example
    linkedin:
      "https://www.linkedin.com/in/arsyadi-indra-hasan-prihambada-991768392/", // Example
    instagram: "https://instagram.com/indraprhmbd_",
    email: "indraprhmbd@gmail.com",
  },
};
